import React from "react";
import AuthRoute from "./AuthRoute";

const Auth = () => {
  return <AuthRoute />;
};

export default Auth;
